<template>
  <div class="teacher-tabbar">
    <!-- <van-tabbar
      v-model="activeTabbar"
      inactive-color="#999999"
      active-color="#F5C682"
      :fixed="false"
      @change="changeTabbarHandler"
    >
      <template v-for="item in tabbarItems">
        <van-tabbar-item
          :key="item.label"
          :name="item.name"
        >
          <span>{{ item.label }}</span>
          <template #icon="props">
            <img :src="props.active ? item.activeIcon : item.icon">
          </template>
        </van-tabbar-item>
      </template>
    </van-tabbar> -->
    <van-tabs v-model="activeTabbar">
      <template v-for="item in tabbarItems">
        <van-tab
          v-if="item.show"
          :key="item.name"
          :title="item.label"
          :name="item.name"
          :to="{
            name: item.name
          }"
        />
      </template>
    </van-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TeacherTabbar',
  data: () => ({
    activeTabbar: ''
  }),
  computed: {
    ...mapGetters(['organization']),
    tabbarItems () {
      const { moduleHome, moduleNews, moduleCourses, moduleFonts } = this.organization
      const init = [
        {
          label: moduleHome.title || '主页',
          show: moduleHome.enable,
          name: 'teacher-home',
          icon: require(`@/assets/images/tabbar/teacher/a.png`),
          activeIcon: require(`@/assets/images/tabbar/teacher/active-a.png`)
        },
        {
          label: moduleCourses.title || '课程',
          show: moduleCourses.enable,
          name: 'teacher-courses',
          icon: require(`@/assets/images/tabbar/teacher/b.png`),
          activeIcon: require(`@/assets/images/tabbar/teacher/active-b.png`)
        },
        {
          label: moduleNews.title || '知讯',
          show: moduleNews.enable,
          name: 'teacher-videos',
          icon: require(`@/assets/images/tabbar/teacher/c.png`),
          activeIcon: require(`@/assets/images/tabbar/teacher/active-c.png`)
        },
        {
          label: moduleFonts.title || '集字创作',
          show: moduleFonts.enable,
          name: 'teacher-creations',
          icon: require(`@/assets/images/tabbar/teacher/d.png`),
          activeIcon: require(`@/assets/images/tabbar/teacher/active-d.png`)
        }
      ]
      return init
    }
  },
  watch: {
    '$route.name' (activeName) {
      console.log('活动的 TeacherTabbar', activeName)
      this.activeTabbar = activeName
    }
  },
  created () {
    const { name } = this.$route
    this.activeTabbar = name
  },
  methods: {
    changeTabbarHandler (activeName) {
      this.$router.push({ name: activeName })
    }
  }
}
</script>

<style scoped lang="scss">
.teacher-tabbar {
  .van-tabs {
     margin-top: 10px;
    ::v-deep {
      .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
        border: 0 solid transparent;
      }
      .van-tabs__wrap {
        height: initial;
        .van-tabs__nav {
          background-color: transparent;
          &.van-tabs__nav--line {
            height: 30px;
            padding-bottom: 0;
          }
        }
        .van-tabs__line {
          @include lg-radius(#E6AC67, #F5C993, 2px);
          bottom: 0;
        }
      }
    }
  }
}
</style>
